import { Series } from '@goldcast/api/backend';

/* eslint-disable no-unused-vars */
export const enum FilterBy {
  AllSeries,
  UpcomingSeries,
  PastSeries
}

export const enum SortBy {
  TitleDescending,
  TitleAscending,
  NewEventDateDescending,
  NewEventDateAscending,
  UpdatedDateAscending,
  UpdatedDateDescending
}
/* eslint-enable no-unused-vars */

export interface State {
  seriesList: Series[] | {};
  filterBy: FilterBy;
  sortBy: SortBy;
  currentPage: number;
  seriesPerPage: number;
  seriesCount: number;
  isUpdateEventLoading: boolean;
  searchTerm?: string;
  selectedTagIds?: string[];
}
